import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3eb47dcc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "90%",
    "margin-left": "5%"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "col_bblue"
};
const _hoisted_4 = {
  key: 1,
  class: "col_bblue"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0,
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_7 = {
  key: 1,
  style: {
    "color": "rgb(126,127,134)",
    "margin-left": "30px"
  }
};
const _hoisted_8 = {
  key: 2,
  style: {
    "color": "rgb(126,127,134)",
    "margin-left": "30px"
  }
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_11 = {
  key: 2,
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_12 = {
  key: 3,
  style: {
    "margin": "20px 0 0 10px",
    "color": "#D9001B",
    "display": "flex"
  }
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "white-space": "nowrap",
    "margin-right": "20px"
  }
}, " 补充备注: ", -1));

const _hoisted_14 = {
  style: {
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_15 = {
  style: {
    "white-space": "nowrap",
    "margin-right": "20px"
  }
};
const _hoisted_16 = {
  style: {
    "width": "80%",
    "word-wrap": "break-word"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_form = _resolveComponent("el-form");

  const _component_el_divider = _resolveComponent("el-divider");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$props.status && $props.status != '1' && $props.status != '5' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.status == '2' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 审核中 ")) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.statusName), 1))], 64)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($options.getClassByStatus($data.dataInfo.answerVo.checkStatus))
  }, _toDisplayString($data.dataInfo.answerVo.checkStatusName), 3))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass($data.dataInfo.isEssential ? 'star' : ''),
    style: {
      "font-weight": "bold",
      "margin-bottom": "10px",
      "font-size": "14px",
      "word-wrap": "break-word",
      "margin-right": "150px"
    }
  }, _toDisplayString($data.dataInfo.sortIndex) + "." + _toDisplayString($data.dataInfo.title || '标题'), 3), $props.isView ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.status ? (_openBlock(), _createElementBlock("div", _hoisted_5, [$data.dataInfo.answerVo.content && $data.dataInfo.answerVo.content != 'null' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_input, {
    modelValue: $data.dataInfo.content,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dataInfo.content = $event),
    placeholder: $props.isAdmin ? $props.damageRTextL.pleaseEnterContent : '请输入内容',
    type: "textarea",
    disabled: "",
    resize: "none"
  }, null, 8, ["modelValue", "placeholder"])])) : $props.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 用户未填报 ")) : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($props.damageRTextL.userHasNotFilledOut), 1))])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_input, {
    modelValue: $data.dataInfo.content,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.dataInfo.content = $event),
    placeholder: $props.isAdmin ? $props.damageRTextL.pleaseEnterContent : '请输入内容',
    type: "textarea",
    disabled: "",
    resize: "none"
  }, null, 8, ["modelValue", "placeholder"])])]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_form, {
    model: $data.dataInfo,
    ref: "ruleForm",
    class: "demo-ruleForm"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      prop: "content",
      style: {
        "width": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.dataInfo.content,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dataInfo.content = $event),
        placeholder: $props.damageRTextL.pleaseEnterContent,
        type: "textarea",
        onChange: _cache[3] || (_cache[3] = $event => $options.saveData(false)),
        resize: "none"
      }, null, 8, ["modelValue", "placeholder"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"])])), $data.dataInfo.answerVo?.checkStatus === '1' && $props.status != '2' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [$props.isAdmin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_15, _toDisplayString($props.damageRTextL.additionalRemarks) + ": ", 1), _createElementVNode("div", _hoisted_16, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)], 64))])) : _createCommentVNode("", true)]), _createVNode(_component_el_divider)]);
}